import Aegis from 'aegis-web-sdk';
// 实例化 aegis 上报日志
const aegis = new Aegis({
    id: 'KJ3R5fqQrLKZRmroyK', // 上报 id
});

export default aegis;
